var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"place_order_btn",attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.placeOrder()}}},[(_vm.loading)?[_c('i',{staticClass:"fa fa-spinner fa fa-spin"}),_c('span',[_vm._v("CARREGANDO")])]:_c('span',[_vm._v(_vm._s(_vm.btnText))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }